"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Select = _interopRequireDefault(require("../Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var countries = require("./countries.json");

var renderOption = function renderOption(_ref) {
  var name = _ref.name,
      cca3 = _ref.cca3;
  return _react.default.createElement("option", {
    key: cca3,
    value: name
  }, name);
};

renderOption.propTypes = {
  name: _propTypes.string.isRequired,
  cca3: _propTypes.string.isRequired
};
renderOption.displayName = 'renderOption';

var CountryPicker = function CountryPicker(_ref2) {
  var prioritise = _ref2.prioritise,
      props = _objectWithoutPropertiesLoose(_ref2, ["prioritise"]);

  var topCountries = countries.filter(function (c) {
    return prioritise.includes(c.name);
  });
  var rest = countries.filter(function (c) {
    return !prioritise.includes(c.name);
  });
  return _react.default.createElement(_Select.default, props, topCountries.length > 0 && [topCountries.sort(function (a, b) {
    return prioritise.indexOf(a.name) > prioritise.indexOf(b.name) ? 1 : -1;
  }).map(renderOption), _react.default.createElement("option", {
    key: "topseparator",
    value: "",
    disabled: true
  })], rest.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(renderOption));
};

CountryPicker.displayName = 'CountryPicker';
CountryPicker.propTypes = {
  prioritise: (0, _propTypes.arrayOf)(_propTypes.string),
  placeholder: _propTypes.string
};
CountryPicker.defaultProps = {
  prioritise: [],
  placeholder: 'Please select'
};
var _default = CountryPicker;
exports.default = _default;